// extracted by mini-css-extract-plugin
export var change = "_3d-1";
export var changeList = "_3d-0";
export var changePath = "_3d-2";
export var diffArrow = "_3d-5";
export var diffRow = "_3d-3";
export var diffValue = "_3d-4";
export var error = "_3d-8";
export var notice = "_3d-9";
export var result = "_3d-6";
export var success = "_3d-7";